import React from 'react';
import { DistanceLabelProps } from './types';
import { OverlayView } from '@react-google-maps/api';
import { ArcStack } from '@src/core/ui';
import { labelStyle } from './styles';
import { arcSpatiumConvert } from '@src/core/extensions/arc-spatium-convert';
import { arcSpatium } from '@src/core/extensions';

const getPixelPositionOffset = (
  width: number,
  height: number
): { x: number; y: number } => ({
  x: -(width / 2),
  y: -(height + 5),
});


const DistanceLabel: React.FC<DistanceLabelProps> = (props) => {
  const { path } = props;

  const segments = React.useMemo(() => {
    const segments = [];
    for (let i = 0; i < path.length - 1; i++) {

      const lat1 = path[i].lat;
      const lng1 = path[i].lng;

      const lat2 = path[i + 1].lat;
      const lng2 = path[i + 1].lng;

      const p1 = new google.maps.LatLng(lat1, lng1);
      const p2 = new google.maps.LatLng(lat2, lng2);

      const midpoint = google.maps.geometry.spherical.interpolate(p1, p2, 0.5);
      const distance = google.maps.geometry.spherical.computeDistanceBetween(p1, p2);

      segments.push({
        distance,  
        midpoint,
      });   
    }
    return segments;
  }, [path]);


  return (
    <React.Fragment>
      {segments.map((s, idx) => {
        const value = arcSpatiumConvert(s.distance);
        return (
          <OverlayView 
            key={idx} 
            position={s.midpoint}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            getPixelPositionOffset={getPixelPositionOffset}>
            <ArcStack style={labelStyle}>
              {arcSpatium(value)}
            </ArcStack>
          </OverlayView>
        );
      })}
    </React.Fragment>
  );
};

export default DistanceLabel;